import React from 'react';
import { Modal } from 'antd';
import aiGeneratingImage from "../../assets/logos/bro.svg" // update path as needed

const AiGeneratingModal = ({ open }) => {
  return (
    <Modal
      open={open}
      footer={null}
      closable={false}
      centered
      bodyStyle={{
        textAlign: 'center',
        padding: '30px 20px',
      }}
    >
      <img
        src={aiGeneratingImage}
        alt="AI generating"
        style={{
          width: '240px',
          height: 'auto',
          marginBottom: '20px',
        }}
      />
      <h3
        style={{
          color: '#E75C4A',
          fontWeight: 600,
          fontSize: '20px',
          margin: 0,
        }}
      >
        AI is generating question
      </h3>
    </Modal>
  );
};

export default AiGeneratingModal;
